import React from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import { useTheme } from '@material-ui/core/styles';

import CaseIcon from '../../assets/icons/CaseIcon';

import { BarChart } from '../charts';

import './home.scss';

const DashboardChart = ({ tenantColor, data, loading }) => {
  const theme = useTheme();
  const chartTheme = {
    fontSize: '12px',
    fontFamily: 'Inter',
    textColor: theme.palette.text.primary,
    axis: {
      ticks: {
        line: {
          stroke: theme.palette.divider,
        },
        text: {
          fill: theme.palette.text.primary,
        },
      },
      legend: {
        text: {
          fill: theme.palette.text.primary,
        },
      },
    },
    grid: {
      line: {
        stroke: theme.palette.divider,
      },
    },
  };

  return (
    <div className="chart__container">
      <div className="d-flex font-size-bg font-bold">
        <CaseIcon color='var(--app-text)' />
        <span className="m-l-md">Cases this week</span>
      </div>

      {loading ? (
        <div className='width-100 height-100 d-flex flex-center'>
          <CircularProgress />
        </div>
      ) : (
        <BarChart
          data={data}
          colors={tenantColor}
          margin={{ top: 20, right: 15, bottom: 50, left: 20 }}
          theme={chartTheme}
        />
      )}
    </div>
  );
};

export default DashboardChart;
